const initialStateLanguages = {
    data: [],
    defaultLanguage: 'english-united-states',
};

function languageReducer(state, action) {
    switch (action.type) {
        case 'SET_LANGUAGE':
            return {
                ...state,
                defaultLanguage: action.payload,
            };
        case 'UNSET_LANGUAGE':
            return {
                ...state,
                defaultLanguage: action.payload,
            };
        default:
            return state;
    }
}

// Main reducer
const mainReducer = ({ languages }, action) => ({
    languages: languageReducer(languages, action),
    // anothers reducers
});

// Global initial state with multiple state reducers
// This allow start the state at the App.js
export const mainState = {
    languages: initialStateLanguages,
    // anothers initialState
};

export default mainReducer;
